import { withAuthenticationRequired } from "@auth0/auth0-react";
import { PageLoader } from './PageLoaderComponent'; 

export const AuthenticationGuard = ({component}) => {
    const Component = withAuthenticationRequired(component, {
        onRedirecting: () => (
            <div>
                <PageLoader />
            </div>
        )
    });

    return <Component />
} 